import contentIsOnly from '../contentState/contentIsOnly';

export default (predicateFn) => {
    const contentStateIsOnlyFn = contentIsOnly(predicateFn);
    return (editorState) => contentStateIsOnlyFn(editorState.getCurrentContent());
};
